module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.7b225d4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Medium.woff
// module id = r2nm
// module chunks = 0